import React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { orange, red, grey, indigo } from '@material-ui/core/colors';
import { MuiThemeProvider, createMuiTheme, createGenerateClassName } from '@material-ui/core/styles';

import reducers from './reducers';
import LoaderExternalInterface from './services/LoaderExternalInterface';
import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

const generateClassName = createGenerateClassName({
	productionPrefix: 'aaanalysesounds'
});

const theme = createMuiTheme({
	typography: {
		fontFamily: 'Open Sans'
	},
	palette: {
		primary: indigo,
		secondary: orange,
		error: red,
	},
	overrides: {
		MuiButton: {
			label: {
				fontWeight: 600
			},
			sizeLarge: {
				fontSize: '1.1rem'
			}
		},
		MuiTypography: {
			subheading: {
				fontSize: '1.1rem'
			},
			headline: {
				color: grey[800],
			},
			title: {
				color: grey[700]
			},
			display1: {
				fontSize: '1.8rem'
			}
		}
	}
});

window.loader.exercises.aaanalysesounds = {};

window.loader.exercises.aaanalysesounds.render = (el, base, testMode, onDataLoaded) => {
	const store = createStore(
		reducers,
		{},
		applyMiddleware(thunk)
	);

	const loaderExternalInterface = new LoaderExternalInterface(store, base);

	ReactDOM.render(
		<Provider store={store}>
			<JssProvider generateClassName={generateClassName}>
				<MuiThemeProvider theme={theme}>
					<App
						loaderAppElement={el}
						loaderExternalInterface={loaderExternalInterface}
						base={base}
						testMode={testMode}
						onDataLoaded={onDataLoaded}
						store={store}
					/>
				</MuiThemeProvider>
			</JssProvider>
		</Provider>
		, el);

	return loaderExternalInterface;
};

// registerServiceWorker();
